import { Component,Inject, Input, OnInit, AfterViewInit, OnDestroy } from "@angular/core";

import { DeviceDetectorService } from "ngx-device-detector";
import {_,mySynchEnumeration} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { BroadCastService } from "../../services/broadcast.service";
import { MySynchEnumerationService } from "../../services/mysynch.enumeration.service";
import { PerformanceMetricsService } from "../../services/performance-metrics.service";

@Component({
    standalone: false,
    selector:"navigation-submenu",
    templateUrl: "../app/navigation/navigation-submenu/navigation-submenu.view.html",
})
export class NavigationSubmenu implements OnInit, AfterViewInit, OnDestroy {
    @Input() submenuView:any;
    @Input() menuIndex:number;
    private _:any;
    private numFarms:any = 1;
    private currentPageType:string = undefined;
    private isMobile:boolean = this.deviceDetector.isMobile();

    private currentPageTypeSubscription:any;
    private onEnableSingleFarmLinksSubscription:any;
    private onStateChangeSubscription:any;

    constructor(@Inject('MySynchFactory') private MSF:any, 
    @Inject('ViewAuthorizationFactory') private viewAuth:any,
    @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
    @Inject(BroadCastService) private broadCastSrv:BroadCastService,
    @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
    @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
    @Inject('F360Constant') private constant:any,
    //@Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
    @Inject(ClientLoggerService) private log:ClientLoggerService
    ) {

        this._ = _;

      }


      private onClickNavLink(link){
    
        if(this.isMobile){
            this.broadCastSrv.toggleNavigationMsg("");
        }
        var action = _.get(link,'action');
        if(!_.isUndefined(action)){
           var actionSource = _.get(action,'source')  as string;
           var actionFunction = _.get(action,'function') as string;
           if(!_.isUndefined(actionSource) && !_.isUndefined(actionFunction)){
              var source = (_.isEqual(actionSource,"self")) ? this : this[actionSource];
              source[actionFunction]();
           }

        }
        var pageType = _.get(link,'pageType')  as string;
        this.mysynchDataStore.setCurrentPageType(pageType);
        var state = _.get(link,'stateName');
        if(!_.isUndefined(state) && !_.isEmpty(state)){
            var optionalStateParams = _.get(link,'optionalStateParams',{});
            this.MSF.loadPage(state,optionalStateParams);
        }
    }

    private enableSingleFarmLinks(){
         var singleFarmLinks = this._.filter(this.submenuView.navLinks,{pageType:"SingleFarm"});
         this._.forEach(singleFarmLinks,(navLink)=>_.set(navLink,'isDisabled',false));
    }
    private disableSingleFarmLinks(){
        var singleFarmLinks = this._.filter(this.submenuView.navLinks,{pageType:"SingleFarm"});
        this._.forEach(singleFarmLinks,(navLink)=>_.set(navLink,'isDisabled',true));
    }

    private checkRole(requiredRoles){
        return !requiredRoles || this.viewAuth.hasRole(requiredRoles)
    }
    private checkRolePermission(requiredPermission) {
       return !requiredPermission || this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumerationName("Permission",requiredPermission));
    };
    private checkHerdSofwarePermission(allowedHerdSoftware){
        return this.viewAuth.hasHerdSoftwarePermission(allowedHerdSoftware);
    };
    private checkFarmInBeta(requiredBetas){
        return this.viewAuth.farmIsInBeta(requiredBetas);
    };

    private getFilteredNavLinksByPermisson() {
        return _.filter(this.submenuView.navLinks,(navLink:any) => {
            return (_.compact(_.map(_.map(navLink.dropdown, 'permission'), this.checkRolePermission)).length || this.checkRolePermission(navLink.permission))
                && this.checkHerdSofwarePermission(_.get(navLink,'allowedHerdSoftware'));
        });
    };
     
    ngOnDestroy(): void {
        if(this.currentPageTypeSubscription){
            this.currentPageTypeSubscription.unsubscribe();
        }
        if(this.onEnableSingleFarmLinksSubscription){
            this.onEnableSingleFarmLinksSubscription.unsubscribe();
        }
        if(this.onStateChangeSubscription){
            this.onStateChangeSubscription.unsubscribe();
        }
    }
    ngOnInit(){
        //this.perfMetricSvc.startTiming(`Component:NavigationSubmenu:${this.submenuView.name}:Render`);
        var availableFarms = this.MSF.getAvailableFarms();
        this.numFarms = _.get(availableFarms,"length",1);
        this.currentPageTypeSubscription = this.mysynchDataStore.currentPageType
                            .subscribe((pageType)=>{
                                if(_.includes(['MultiFarm','Admin'],pageType) ){
                                   this.disableSingleFarmLinks();
                                }
                                this.currentPageType = this._.cloneDeep(pageType);
                            });
        this.onEnableSingleFarmLinksSubscription = this.broadCastSrv.onEnableSingleFarmLinks()
        .subscribe((msgData)=>{
            this.enableSingleFarmLinks();   
        });

        this.onStateChangeSubscription = this.broadCastSrv.onStateChange()
        .subscribe((msgData)=>{
             var stateName = _.get(msgData,'state.name');
             var submenuNavLinkStatesNames = _.compact(_.pluck(_.get(this.submenuView,'navLinks',[]),'stateName'));

            if(_.includes(submenuNavLinkStatesNames,stateName) && this.submenuView.collapsed){
                this.submenuView.collapsed = false;
            }

        });

        this.MSF.waitForElm("#sitenav-submenu-"+this.submenuView.name).then((elm)=>{
            $("#sitenav-submenu-"+this.submenuView.name).on('shown.bs.collapse',()=>{
                this.submenuView.collapsed = false; 
            });
    
            $("#sitenav-submenu-"+this.submenuView.name).on('hidden.bs.collapse',()=>{
                this.submenuView.collapsed = true;  
            });
       })

       
        

        
    }
    ngAfterViewInit(){
          this.MSF.ready(()=>{
            //this.perfMetricSvc.endTiming("component",`Component:NavigationSubmenu:${this.submenuView.name}:Render`);
          });
    }
}